<template>
  <help-dialog title="Select AI Model">
    <template #default>
      <h3 class="mb-1">Get help from the AI copilot</h3>
      <p class="text-grey-darken-3">
        Choose which model to use when generating events, cards, read models, commands, etc.
      </p>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'
</script>
